import { BlankModal, ModalBody, ModalFooter, ModalHeader, Button, Spinner } from '@cad-arc';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';
import { useCallback, useState } from 'react';
import { useApiClient } from '~/api-client';
import { useQuery } from '@tanstack/react-query';
import { CadPrintResource } from '@mark43/cad-api';
import { BaseSelect } from '../forms/inputs/base-select';

export type GenerateLogModalComponentType = typeof GenerateLogModal;

export function GenerateLogModal({
    onSelect,
}: {
    onSelect: (printingTemplateId?: number) => void;
}) {
    const modalControls = useFullscreenModalControls();
    const [printingTemplateId, setPrintingTemplateId] = useState<number>();
    const apiClient = useApiClient();

    const printingTemplateQuery = useQuery(['event-pdf-templates'], {
        queryFn: () => {
            return apiClient.request<CadPrintResource.GetEventPdfTemplates>({
                method: 'GET',
                url: 'cad_print/event/pdf_templates',
            });
        },
        onSuccess(data) {
            setPrintingTemplateId(data.data?.data?.templates?.[0]?.value);
        },
    });

    const onCancel = useCallback(() => {
        modalControls.close();
    }, [modalControls]);

    return (
        <BlankModal isOpen={true} onClose={onCancel} isCentered>
            <ModalHeader>Select Printing Template</ModalHeader>
            <ModalBody>
                {printingTemplateQuery.isLoading ? (
                    <Spinner />
                ) : (
                    <BaseSelect
                        value={printingTemplateId}
                        options={printingTemplateQuery?.data?.data?.data?.templates ?? []}
                        onChange={(e) => setPrintingTemplateId(e.target.value)}
                    />
                )}
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={() => {
                        onSelect(printingTemplateId);
                        onCancel();
                    }}
                    isDisabled={!printingTemplateId}
                >
                    OK
                </Button>
            </ModalFooter>
        </BlankModal>
    );
}
